var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_89_343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6502 14.4639C28.6502 6.73188 22.3822 0.463867 14.6502 0.463867C6.91819 0.463867 0.650177 6.73188 0.650177 14.4639C0.650177 21.4516 5.76975 27.2435 12.4627 28.2938V18.5107H8.90799V14.4639H12.4627V11.3795C12.4627 7.87074 14.5528 5.93262 17.7507 5.93262C19.2825 5.93262 20.8846 6.20606 20.8846 6.20606V9.65137H19.1192C17.3802 9.65137 16.8377 10.7306 16.8377 11.8378V14.4639H20.7205L20.0998 18.5107H16.8377V28.2938C23.5306 27.2435 28.6502 21.4518 28.6502 14.4639Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0998 18.5107L20.7205 14.4639H16.8377V11.8378C16.8377 10.7306 17.3802 9.65137 19.1192 9.65137H20.8846V6.20605C20.8846 6.20605 19.2825 5.93262 17.7507 5.93262C14.5528 5.93262 12.4627 7.87074 12.4627 11.3795V14.4639H8.90799V18.5107H12.4627V28.2938C13.1755 28.4056 13.9059 28.4639 14.6502 28.4639C15.3945 28.4639 16.1248 28.4056 16.8377 28.2938V18.5107H20.0998Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_89_343"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0.650177 0.463867)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.146bbce5e571a6f65dff59e980c1a9a8.svg";
export { ForwardRef as ReactComponent };